import React from 'react';

import { Message, Spinner } from 'common/components';
import { Glossary, HistoryGL } from 'common/utils/glossary';
import { PurchaseHistory, PlanStatus } from './PurchaseHistory';
import { default as PurchaseHistoryListMessage } from '../containers/PurchaseHistoryListMessage';

interface PurchaseHistoryListsProps {
  /** 購入履歴のリスト */
  purchaseHistorys: {
    vendorPurchaseId: string;
    planName: string;
    operationDatetime: string;
    status: PlanStatus;
    isShow: boolean;
    onClickPurchase: () => void;
    onClickDetail: () => void;
  }[];
  /** 初期化処理 */
  initializePage: () => void;
  /** グロッサリ */
  glossary: Glossary;
  /** ログイン済みか否か */
  isLoggedIn: boolean;
  /** 購入履歴取得中か否か */
  isProcessing: boolean;
}

/**
 * 購入履歴リストのPresentation Component
 */
export const PurchaseHistoryLists: React.FC<PurchaseHistoryListsProps> = ({
  purchaseHistorys,
  initializePage,
  glossary,
  isLoggedIn,
  isProcessing
}) => {
  // 初期化処理のイベント
  React.useEffect(() => {
    initializePage();
  }, []);

  // リスト部に表示するComponentをメモライズ
  const listComponent = React.useMemo(() => {
    return purchaseHistorys.map((purchaseHistory) => (
      <PurchaseHistory
        {...purchaseHistory}
        glossary={glossary}
        data-test={purchaseHistory.vendorPurchaseId}
        key={purchaseHistory.vendorPurchaseId}
      />
    ));
  }, [purchaseHistorys]);

  return (
    <div className="purchase" data-test="purchaseHistoryLists">
      <Message
        type="message"
        subType="red"
        data-test="purchaseHistoryLists-message"
      >
        {glossary.glx(HistoryGL.DisplayPeriod)}
      </Message>
      <PurchaseHistoryListMessage />
      {listComponent}
      {!isLoggedIn || isProcessing ? <Spinner /> : null}
    </div>
  );
};
